import { Inject, Injectable } from '@angular/core';
import { Notification, NotificationsService } from 'angular2-notifications';

/**
 * Error notifications stay longer than the global 2.5 s, scaled by message length, so long
 * messages can be read. An explicit `timeOut` passed by the caller still wins.
 */
@Injectable()
export class AppNotificationsService extends NotificationsService {
  private readonly ERROR_MIN_TIMEOUT = 6000; // ms

  private readonly ERROR_MAX_TIMEOUT = 20000; // ms

  private readonly ERROR_MS_PER_CHAR = 60;

  constructor(@Inject('options') globalOptions: any) {
    super(globalOptions);
  }

  error(title?: any, content?: any, override?: any, context?: any): Notification {
    return super.error(
      title,
      content,
      { timeOut: this.errorTimeOut(title, content), ...override },
      context,
    );
  }

  private errorTimeOut(title: any, content: any): number {
    const length = `${title ?? ''} ${content ?? ''}`.length;
    const timeOut = length * this.ERROR_MS_PER_CHAR;
    return Math.min(Math.max(timeOut, this.ERROR_MIN_TIMEOUT), this.ERROR_MAX_TIMEOUT);
  }
}
